const IconDotPartially = () => (
    <span role="img" className="anticon">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 12"
            width="1em"
            height="1em"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M2 5.125c0-1.726 1.4-3.125 3.125-3.125h1.75c1.726 0 3.125 1.4 3.125 3.125v1.75c0 1.726-1.4 3.125-3.125 3.125h-1.75a3.125 3.125 0 0 1-3.125-3.125zm2.47-1.758c-.455.17-.828.513-1.037.949l4.252 4.25c.435-.208.778-.58.948-1.037zm1.651-.117 2.629 2.629v-.754c0-1.036-.84-1.875-1.875-1.875zm-2.871 3.625v-.975l2.85 2.85h-.975a1.875 1.875 0 0 1-1.875-1.875"
            />
        </svg>
    </span>
);


export default IconDotPartially;
